module.exports = __webpack_public_path__ + "static/media/cross.d96ed581.svg";